import React from 'react';

import './MenuLeft.scss';
import '../../../styles/svg_icons/logo_main.svg';
import mainLogo from'../../../styles/svg_icons/logo_main.svg';
import Searcher from '../Searcher/Searcher';
import { showMenuView } from '../../Menu/MenuSide/menuSideSlice';



const MenuLeft = (props) =>{
    const {dispatch} = props;
   const handleClickMenu = () => {
        dispatch(showMenuView());
        
   }
        return (
            <div className="MenuLeft">

                <div className='img-container'>
                    <button className='menu-button' onClick={handleClickMenu}><p className='menu-title'>Меню</p></button>
                    <img src={mainLogo} className="logo-main" alt="logo" />
                </div>
               {/*<Searcher /> */} 
                

            </div>
        )
   
}
export default  MenuLeft;